import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconScanOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M5 20a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1m22 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h5v-5a1 1 0 0 1 1-1m-9.333-2.333a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zm2.666-5.334a1 1 0 0 1 0 2h-8.666a1 1 0 1 1 0-2zM11 4a1 1 0 1 1 0 2H6v5a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1zm16 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V6h-5a1 1 0 1 1 0-2z" /></svg>;
export default SvgIconScanOutlined;